//--------------- IMPORTAÇÕES ---------------//
import { useContext } from "react";
import { IntegracoesContext } from "../../context/IntegracoesContext";
import { createIntegrationService, loadIntegrationsService } from "../../services";
import { LoadingContext } from "../../../../shared/context/LoadingContext"



//--------------- EXPORTAÇÃO DO COMPONENTE MAIN ---------------//
export default function ModalCreateIntegration() {



    //--------------- CRIAÇÃO DE HOOKS ---------------//
    const { integrations, setIntegrations } = useContext(IntegracoesContext); // Estado que armazena a lista de Tags
    const { isOpenModalCreateIntegration, setIsOpenModalCreateIntegration } = useContext(IntegracoesContext);
    const { formDataModalCreateIntegration, setFormDataModalCreateIntegration } = useContext(IntegracoesContext); // Estado que armazena se Tag deve ser deletada
    const { isLoading, setIsLoading } = useContext(LoadingContext);


    //--------- FUNÇÃO ASSÍNCRONA CONFIRMAR DELEÇÃO --------//
    // Nesta função, é deletada a Tag selecionada do Banco de Dados via API.
    const handleConfirmCreate = async () => {
        const response = await createIntegrationService(formDataModalCreateIntegration);
        if (response) {
            setFormDataModalCreateIntegration(null);
            setIsOpenModalCreateIntegration(false);
            handleRefreshIntegrations();
        }
    };



    //-------- FUNÇÃO ASSÍNCRONA CARREGAR TAGS ----------//
    // Nesta função, é requisitado à API as INTEGRAÇÕES armazenadas.
    // AS INTEGRAÇÕES retornadas pela API são armazenadas no Estado "integrations" .
    async function handleRefreshIntegrations() {
        setIsLoading(true);
        const response = await loadIntegrationsService();
        if (response) {
            setIntegrations(response.data);
        }
        setIsLoading(false);
    };



    //--------------- FUNÇÃO DE SELEÇÃO DA PLATAFORMA ---------------//
    const handleSelectPlataforma = (plataforma) => {
        setFormDataModalCreateIntegration({
            ...formDataModalCreateIntegration,
            plataforma,
        });
    };


    //--------------- FUNÇÃO DE MUDANÇA DO NOME ---------------//
    const handleChangeNome = (e) => {
        setFormDataModalCreateIntegration({
            ...formDataModalCreateIntegration,
            nome: e.target.value,
        });
    };



    //--------------- RETORNO DO COMPONENTE MAIN ---------------//
    return (
        <>

            {/* DIV DE CONFIRMAÇÃO DE EXCLUSÃO DE TAG */}
            {!isOpenModalCreateIntegration
                ? null
                :
                <>
                    {/* DIV BACKDROP */}
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">


                        {/* DIV MODAL */}
                        <div className="bg-surface-1 p-6 rounded shadow-md w-[90vw] max-w-md border border-white/[0.08]">


                            {/* TÍTULO DO MODAL */}
                            <h2 className="text-xl font-semibold mb-4">Criar Nova Integração</h2>


                            {/* INPUT NOME DA INTEGRAÇÃO */}
                            <div className="mb-4">
                                <label className="block text-ink-3 mb-2">Nome da Integração:</label>
                                <input
                                    type="text"
                                    value={formDataModalCreateIntegration?.nome || ""}
                                    onChange={handleChangeNome}
                                    placeholder="Digite o nome da integração"
                                    className="w-full px-3 py-2 bg-surface-2 border border-white/[0.08] rounded text-white"
                                />
                            </div>


                            {/* DESCRIÇÃO */}
                            <div className="mb-4">
                                <strong className="block text-ink-3 mb-2">Escolha uma plataforma:</strong>
                                <div className="flex gap-2">
                                    <button
                                        onClick={() => handleSelectPlataforma("hotmart")}
                                        className={`flex items-center gap-2 px-4 py-2 rounded border text-sm transition-all
${formDataModalCreateIntegration?.plataforma === "hotmart"
                                                ? "bg-brand-600 border-brand-700"
                                                : "bg-surface-2 border-white/[0.08] hover:bg-surface-3"}`}
                                    >
                                        🔥 Hotmart
                                    </button>


                                    <button
                                        onClick={() => handleSelectPlataforma("wordpress")}
                                        className={`flex items-center gap-2 px-4 py-2 rounded border text-sm transition-all
${formDataModalCreateIntegration?.plataforma === "wordpress"
                                                ? "bg-brand-600 border-brand-700"
                                                : "bg-surface-2 border-white/[0.08] hover:bg-surface-3"}`}
                                    >
                                        🌐 WordPress
                                    </button>

                                    <button
                                        onClick={() => handleSelectPlataforma("kiwify")}
                                        className={`flex items-center gap-2 px-4 py-2 rounded border text-sm transition-all
${formDataModalCreateIntegration?.plataforma === "kiwify"
                                                ? "bg-brand-600 border-brand-700"
                                                : "bg-surface-2 border-white/[0.08] hover:bg-surface-3"}`}
                                    >
                                        🍉 Kiwify
                                    </button>

                                    <button
                                        onClick={() => handleSelectPlataforma("lastlink")}
                                        className={`flex items-center gap-2 px-4 py-2 rounded border text-sm transition-all
${formDataModalCreateIntegration?.plataforma === "lastlink"
                                                ? "bg-brand-600 border-brand-700"
                                                : "bg-surface-2 border-white/[0.08] hover:bg-surface-3"}`}
                                    >
                                        🔗 Lastlink
                                    </button>
                                </div>
                            </div>


                            {/* BOTÕES DE AÇÃO */}
                            <div className="flex justify-end gap-2">
                                <button
                                    onClick={() => setIsOpenModalCreateIntegration(false)}
                                    className="bg-surface-3 hover:bg-surface-4 px-4 py-2 rounded"
                                >
                                    Cancelar
                                </button>
                                <button
                                    onClick={handleConfirmCreate}
                                    className="bg-green-600 hover:bg-green-700 px-4 py-2 rounded"
                                >
                                    Confirmar
                                </button>
                            </div>


                        </div>
                    </div>
                </>
            }

        </>
    )
}